<template>
  <div>
    <top title="申请记录" path="/home">
      <diaodu-menu slot="center"></diaodu-menu>
    </top>
    <my-tab :tab="tab" :active="active" @tab="reTab"></my-tab>
    <ly-time @timeObj='reTimeObj'></ly-time>
    <div id="mylist" style="top: 130px">
      <List
        v-for="(item, index) in listData"
        :key="index"
        @on-click="openXiangqing(item)"
      >
        <template slot="title">{{ item.user }} </template>
        <template slot="day"
          >创建：{{ utils.time(item.applyTime, "yymmddhhmm") }}</template
        >
        <template slot="des">
          订单编号：{{ item.applyId }} / 联系电话：{{ item.tel }} <br />
          预计用车：{{ utils.time(item.planUseTime, "yymmddhhmm") }}
        </template>
      </List>
    </div>
    <Modal
      v-model="xiangqing"
      title="详情"
      :mask-closable="false"
      width="90%"
      footer-hide
      fullscreen
    >
      <Detail :datas="datas">
        <Row slot="btn" style="margin-top: 20px">
          <!-- <Col span="8"><Button long>编辑</Button></Col>
          <Col span="8"><Button long>撤回</Button></Col> -->
          <Col span="12"
            ><Button
              long
              @click="agreeDisagree(1)"
              :disabled="
                applyItem.approvalStatus != 0 || applyItem.taskStatus == 5
              "
              type="primary"
              >通过</Button
            ></Col
          >
          <Col span="12"
            ><Button
              long
              @click="agreeDisagree(2)"
              :disabled="
                applyItem.approvalStatus != 0 || applyItem.taskStatus == 5
              "
              >驳回</Button
            ></Col
          >
        </Row>
      </Detail>
    </Modal>
  </div>
</template>
<script>
import diaoduMenu from "../common/diaoduMenu.vue";
import axios from "axios";
export default {
  data() {
    return {
      value: 0, //标签默认展开
      value1: "0", //折叠面板默认展开
      listData: [],
      tab: [
        { title: "待审批", mark: 0 },
        { title: "已审批", mark: 1 },
        { title: "被驳回", mark: 2 },
      ],
      active: 0,
      xiangqing: false,
      datas: [],
      applyItem: {},
      timeObj:{}
    };
  },
  components: {
    diaoduMenu,
  },
  methods: {
    //获取计费类型
    getList() {
      var params = {
        approvalStatus: this.active,
        startTime: this.timeObj.start,
        endTime: this.timeObj.end,
      };
      axios({
        method: "post",
        url: axios.dispatch + "/approval/list",
        data: params,
      }).then((res) => {
        var data = res.data.data.dataList;
        this.listData = data;
      });
    },
    reTab(v) {
      this.active = v.mark;
      this.getList();
    },
    openXiangqing(row) {
      this.applyItem = row;
      this.xiangqing = true;
      this.datas = [
        {
          title: "单号",
          value: row.applyId,
        },
        {
          title: "用车人",
          value: row.user,
        },
        {
          title: "电话",
          value: row.tel,
        },
        {
          title: "单位名称",
          value: row.groupName,
        },
        {
          title: "开始地点",
          value: row.startAdd,
        },
        {
          title: "送达地点",
          value: row.endAdd,
        },
        {
          title: "预计用车",
          value: this.utils.time(row.planUseTime),
        },
        {
          title: "预计还车",
          value: this.utils.time(row.planReturnTime),
        },
        {
          title: "预计事由",
          value: row.des,
        },
      ];
    },
    agreeDisagree(t) {
      var params = {
        applyId: this.applyItem.applyId,
        approvalStatus: t,
      };
      this.$Modal.confirm({
        title:
          t == 1 ? "操作后无法恢复，确定同意？" : "操作后无法恢复，确定驳回？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.dispatch + "/approval/execute",
            data: params,
          }).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              this.getList();
              this.xiangqing = false;
            } else {
              this.$Message.error(res.data.message);
            }
          });
        },
      });
    },
    //点击选项卡触发
    changeTabs(x) {
      this.getList(x);
      this.value = x;
    },
    reTimeObj(v){
      this.timeObj=v;
      this.getList();
    }
  }
};
</script>
<style lang="">
.label {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/approval/approval.vue